import { useQuery } from "react-query";
import {
    ParamsGetWarehouse,
    GetWarehouseResponse,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetWarehouse) => {
    const apiGetWarehouse = queryString.stringifyUrl({
        url: "api/warehouses",
        query: {
            search: `${params.search}`,
            size: params.size,
            page: params.page,
        },
    });
    const { data } = await axios.get<GetWarehouseResponse>(apiGetWarehouse);
    return data.data;
};

export default function useWarehouse(params: ParamsGetWarehouse) {
    return useQuery<GetWarehouseResponse["data"]>(["warehouse", params], () =>
        handleRequest(params),
    );
}
